import { safeWindow } from "framer-motion"

export function optionalReactDOM() {
    if (typeof safeWindow !== "undefined" && safeWindow["ReactDOM"]) {
        return safeWindow["ReactDOM"]
    }
    return undefined
}
